import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CredentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { AuthService } from './core/services/auth.service';

// Factory function pour le TranslateHttpLoader
export function HttpLoaderFactory(): TranslateLoader {
  // Le loader lit sa config via TRANSLATE_HTTP_LOADER_CONFIG
  return new TranslateHttpLoader();
}

export function initializeAuth(authService: AuthService): () => Promise<boolean> {
  return () => firstValueFrom(authService.bootstrapSession());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([CredentialsInterceptor, AuthInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json',
        // Ajoute automatiquement un cache-buster à chaque chargement de langue
        // (utile en prod/CDN pour éviter de servir un ancien fr.json)
        enforceLoading: true
      }
    },
    ...TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: []
      },
      fallbackLang: 'fr'
    }).providers!
  ]
};
